import { useInitChatOnOngoingConversationEffect } from "@faire/help-center-self-serve/chat/hooks/useInitChatOnOngoingConversationEffect";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { SelfServeBase } from "@faire/help-center-self-serve/SelfServeBase";
import { isLoggedInBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment } from "@faire/help-center-utils/settings/getSettingHelpCenterSearchAndNavImprovements";
import home, { route as homeRoute } from "@faire/web-api/routes/support";
import { route as articleRoute } from "@faire/web-api/routes/support/articles/articleId";
import { route as brandsRoute } from "@faire/web-api/routes/support/brands";
import { route as dsaFormRoute } from "@faire/web-api/routes/support/dsa";
import { route as popularGuideRoute } from "@faire/web-api/routes/support/popular-guides/categoryId";
import { route as retailersRoute } from "@faire/web-api/routes/support/retailers";
import { route as searchRoute } from "@faire/web-api/routes/support/search";
import { route as selfServeRoute } from "@faire/web-api/routes/support/self-serve";
import { route as topicRoute } from "@faire/web-api/routes/support/topics/topicId";
import { Route } from "@faire/web/ui/routing/Route";
import { Switch } from "@faire/web/ui/routing/Switch";
import React from "react";
import { Redirect } from "react-router-dom";
import { useDecagon } from "./hooks/chatbot/decagon/useDecagon";
import { LazyArticlePage } from "./views/articles/LazyArticlePage";
import { LazyBrandsHome } from "./views/brands/LazyBrandsHome";
import { LazyDsaForm } from "./views/dsa-form/LazyDsaForm";
import { HomePage } from "./views/home/HomePage";
import { LazyPopularGuidesPage } from "./views/popular-guides/LazyPopularGuidesPage";
import { LazyRetailersHome } from "./views/retailers/LazyRetailersHome";
import { LazySearchPage } from "./views/search/LazySearchPage";
import { LazyTopicPage } from "./views/topic/LazyTopicPage";
export var AppRoutes = function AppRoutes() {
  useInitChatOnOngoingConversationEffect();
  useDecagon();
  var hasAIChatbotAccess = useAIChatbotAccess();
  var LandingPage = function LandingPage() {
    if (getSettingHelpCenterSearchAndNavImprovementsWithoutAssignment()) {
      if (isLoggedInBrand()) {
        return LazyBrandsHome;
      } else {
        return LazyRetailersHome;
      }
    }
    return HomePage;
  };
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: homeRoute,
    component: LandingPage()
  }), /*#__PURE__*/React.createElement(Route, {
    path: brandsRoute,
    component: LazyBrandsHome
  }), /*#__PURE__*/React.createElement(Route, {
    path: retailersRoute,
    component: LazyRetailersHome
  }), /*#__PURE__*/React.createElement(Route, {
    path: searchRoute,
    component: LazySearchPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: popularGuideRoute,
    component: LazyPopularGuidesPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: topicRoute,
    component: LazyTopicPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: articleRoute,
    component: LazyArticlePage
  }), hasAIChatbotAccess ? null : ( /*#__PURE__*/React.createElement(Route, {
    path: selfServeRoute,
    component: SelfServeBase
  })), /*#__PURE__*/React.createElement(Route, {
    path: dsaFormRoute,
    component: LazyDsaForm
  }), /*#__PURE__*/React.createElement(Redirect, {
    path: "".concat(homeRoute, "/contact**"),
    to: "".concat(homeRoute, "?contact=true")
  }), /*#__PURE__*/React.createElement(Redirect, {
    to: home()
  }));
};